/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Stack,
  Typography,
} from '@mui/material';

import ClauseCard from './ClauseCard';
import { highlightedSentence } from '../../hooks/Helper';
import { RootState, useTypedSelector } from '../../redux/store';

interface IProps {
  insights?: any;
  openBoot: VoidFunction;
  setBotFrom: any;
}

const getColor = (color: string) => {
  switch (color) {
    case 'Red':
      return '#ff0000';
    case 'Green':
      return '#11ff00';
    case 'Amber':
      return '#ffbf00';
    default:
      return 'transparent';
  }
};

const Insights = (props: IProps) => {
  const { insights, openBoot, setBotFrom } = props;

  const { instance } = useTypedSelector((state: RootState) => state.draft);

  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [activePara, setActivePara] = React.useState<{
    id: string;
    index: number;
  } | null>();

  const highlight = (id: string) => {
    const textCon = document.getElementById(id);
    if (textCon) {
      insights?.data?.map((data: any) => {
        if (id.includes(data.id)) {
          data?.q3_content?.map((content: any) => {
            if (Array.isArray(content?.answers)) {
              content?.answers?.map((answer: any) => {
                if (answer.sentence) {
                  const searched = answer.sentence.trim();
                  if (searched !== '') {
                    const text = textCon.innerHTML;
                    const newText = text.replace(
                      searched,
                      `<span style="background: ${getColor(answer.color)}; color: marktext">${searched}</span>`
                    );
                    textCon.innerHTML = newText;
                  }
                }
              });
            }
          });
        }
      });
    }
    return null;
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const handleSentenceClick = (sentence: string, index: number, id: string) => {
    setActivePara({ id, index });
    highlightedSentence(sentence, instance);
  };

  return (
    <div>
      {!insights?.pending &&
        insights?.data?.map((data: any, index: any) => (
          <Accordion
            key={`${data?.section_name}-${index}`}
            onChange={handleChange(data?.id)}
            expanded={expanded === data?.id}
            disabled={
              Array.isArray(data?.q1_normalized_content) &&
              data?.q1_normalized_content?.length === 0
            }
            className="according-class"
          >
            <AccordionSummary>
              <Stack
                direction="row"
                sx={{
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center',
                }}
              >
                <Typography>{data?.clause}</Typography>
                <Typography>
                  {Array.isArray(data?.q1_normalized_content)
                    ? data?.q1_normalized_content?.length
                    : 0}
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              {Array.isArray(data?.q1_normalized_content) && (
                <>
                  <Stack>
                    <Stack className="ulta-ai-button-container">
                      <Button
                        className="ulta-ai-button"
                        sx={{
                          alignSelf: 'end',
                          padding: '1.5px 10px',
                          backgroundColor: 'white',
                          margin: '2px 3px',
                          borderRadius: '5px',
                          width: 'fit-content',
                          '&:hover': {
                            backgroundColor: 'white',
                          },
                        }}
                        onClick={() => {
                          openBoot();
                          setBotFrom({
                            type: 'insights',
                            content: {
                              clause: data.clause,
                              data: data?.q1_normalized_content,
                            },
                          });
                        }}
                        startIcon={<ChatBubbleOutlineIcon />}
                        size="small"
                      >
                        Ask Ultra AI
                      </Button>
                    </Stack>
                  </Stack>
                  {data?.q1_normalized_content.map(
                    (para: any, index: number) => {
                      return (
                        <React.Fragment
                          key={`${data?.section_name}-insights-para-${index}`}
                        >
                          {para?.normalized_text && (
                            <ClauseCard
                              onClick={() =>
                                handleSentenceClick(
                                  para.normalized_text,
                                  index,
                                  data?.id
                                )
                              }
                              key={`${data?.section_name}-insights-para-text-${index}`}
                              index={index}
                              isActive={
                                activePara?.index === index &&
                                activePara?.id === data?.id
                              }
                            >
                              <>
                                {highlight(`text-${data?.id}-${index}`)}
                                <Typography id={`text-${data?.id}-${index}`}>
                                  {para?.normalized_text}
                                </Typography>
                              </>
                            </ClauseCard>
                          )}
                        </React.Fragment>
                      );
                    }
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
    </div>
  );
};

export default Insights;
